import request from "./base";
const path = "/api/jobs";

export default {
  list: function (params) {
    return request().get(path + "/", {params});
  },
  getThreads: function (id) {
    return request().get(path + "/threads", {
      params: {id}
    });
  },
  getLogs: function (params) {
    return request().get(path + "/logs", {
      params: params
    });
  },
  create: function (params) {
    return request().post(path + "/", params);
  },
  update: function (params) {
    return request().post(path + "/update", params);
  },
  delete: function(ids) {
    return request().delete(path + "/", {
      data: {ids}
    });
  },
  start: function (id) {
    return request().post(path + "/start", {id});
  },
  stop: function (id) {
    return request().post(path + "/stop", {id});
  },
  restart: function (id) {
    return request().post(path + "/restart", {id});
  },
  clear: function (id) {
    return request().post(path + "/clear", {id});
  },
};
